var React = require('react');

function Vue (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M71.5909 2.99999L72.1683 1.99999H73.323H114.76H118.224L116.492 5L62.612 98.3223L60.88 101.322L59.1479 98.3223L5.26795 5L3.53589 1.99999H7H48.437H49.5917L50.169 2.99999L60.88 21.552L71.5909 2.99999Z","fill":"#4DBA87","stroke":"white","strokeWidth":"3","key":0}),React.createElement("path",{"d":"M73.3228 4.00088L60.8798 25.5529L48.4367 4.00088H28.5518L60.8798 59.9941L93.2078 4.00088H73.3228Z","fill":"#435466","key":1})]);
}

Vue.defaultProps = {"width":"122","height":"106","viewBox":"0 0 122 106","fill":"none","style":{"width":"400px","height":"400px","margin":"0px 20px","opacity":"1","transition":"all 0.3s ease 0s"},"data-testid":"series-logo","aria-label":"vue logo"};

module.exports = Vue;

Vue.default = Vue;
